module.exports = __webpack_public_path__ + "infocentrum23.jpg?74430acabc7599613e8baed1baacef85";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum23.jpg
// module id = 275
// module chunks = 0